import { getCommerceLocal } from '../locale';
const commerceLang = getCommerceLocal();
// returns language in this format: 'sv', 'en', 'de'
/**
 * Utility to format price based in locale
 *
 * @param {number} amount - number, price amount
 * @param {string} currencyCode - string, currency code like 'USD' or 'SEK'
 * @return {string} - formatted price with currency identifier
 */
export const formatPriceLocale = ({ amount, currencyCode, locale, }) => {
    const lang = locale === null || locale === void 0 ? void 0 : locale.split('_')[0];
    return (new Intl.NumberFormat(lang || commerceLang, {
        style: 'currency',
        currency: currencyCode,
    }).format(amount) || '0.00');
};
//# sourceMappingURL=formatPriceLocale.js.map